import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: KpiStoreState = {
  kpi_row_data: {
    month: 0,
    name: '',
    total_revenue: 0,
    year: 0,
    created_at: '',
    created_by_name: '',
  },
};

const setKpiRowData: CaseReducer<KpiStoreState, PayloadAction<KpiOverall>> = (state, action) => {
  state.kpi_row_data = action.payload;
};

const kpiSlice = createSlice({
  name: 'kpiSlice',
  initialState,
  reducers: { setKpiRowData },
});

export const kpiActions = kpiSlice.actions;

export default kpiSlice.reducer;
